export {};
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/scrollmonitor/dist/module/src/types.js
// module id = 656
// module chunks = 0